import { render, staticRenderFns } from "./RaceLink.vue?vue&type=template&id=4fee4f72&"
import script from "./RaceLink.vue?vue&type=script&lang=js&"
export * from "./RaceLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports